import { tw } from "~/utils";

interface LogoProps {
  color: "charcoal" | "teal" | "purple" | "white";
  className?: string;
}

export const Logo = ({ color, className }: LogoProps) => (
  <span
    className={tw(
      color === "charcoal"
        ? "text-charcoal"
        : color === "teal"
          ? "text-teal"
          : color === "white"
            ? "text-offWhite"
            : "text-purple",
      "inline-block",
      className
    )}
  >
    {konnectLogo}
  </span>
);

const konnectLogo = (
  <svg viewBox="0 0 359 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.7 20.5488C110.7 9.07857 119.876 0 131.59 0C143.305 0 152.481 9.12738 152.481 20.5488C152.481 31.9702 143.305 41 131.59 41C119.876 41 110.7 32.019 110.7 20.5488ZM120.364 20.5C120.364 27.1869 125.196 32.1167 131.59 32.1167C137.936 32.1167 142.817 27.2357 142.817 20.5C142.817 13.7643 137.936 8.78571 131.59 8.78571C125.245 8.78571 120.364 13.8131 120.364 20.5ZM20.5 14.5452C23.2333 10.6405 24.9905 5.95476 25.3321 0.878571H15.5214C14.6429 9.02976 8.15119 15.5214 0 16.4V23.3798V25.4786C8.15119 26.3571 14.6429 32.8488 15.5214 41H25.3321C24.9905 35.9238 23.2333 31.2381 20.5 27.3333C18.7917 24.8929 16.644 22.7452 14.2524 20.9393C16.644 19.1821 18.7917 17.0345 20.5 14.5452ZM38.8524 0.878571H29.0417C29.3833 5.95476 31.1405 10.6405 33.8738 14.5452C35.5821 16.9857 37.7298 19.1333 40.1214 20.9393C37.7298 22.6964 35.5821 24.844 33.8738 27.3333C31.1405 31.2869 29.3833 35.9726 29.0417 41H38.8524C39.7309 32.8488 46.2226 26.3571 54.3738 25.4786V23.3798V16.4C46.2226 15.5214 39.7309 9.02976 38.8524 0.878571ZM185.818 24.3071L166.001 0.878571H157.948V40.1214H167.612V17.3762L187.477 40.1214H195.433V0.878571H185.818V24.3071ZM210.32 0.878571L230.186 24.3071V0.878571H239.752V40.1214H231.796L211.98 17.3762V40.1214H202.315V0.878571H210.32ZM256.299 24.4048H275.334V16.5464H256.299V9.17619H277.043V0.878571H246.634V40.1214H277.189V31.775H256.299V24.4048ZM290.953 20.5C290.953 27.1869 295.932 32.2143 302.131 32.2143V32.2631C307.109 32.2631 311.063 29.4321 312.43 23.575L321.899 25.4298C320.093 35.2893 312.186 41 302.131 41C290.465 41 281.289 31.9702 281.289 20.5C281.289 9.02976 290.465 0 302.131 0C311.795 0 319.995 5.71071 321.85 15.0333L312.381 17.2786C311.161 11.5679 307.158 8.83452 302.131 8.83452C295.932 8.83452 290.953 13.8131 290.953 20.5ZM323.607 0.878571V9.32262H336.298V40.1214H345.913V9.32262H358.603V0.878571H323.607ZM107.234 1.17143C106.893 6.19881 105.184 10.8357 102.451 14.7405C100.743 17.1809 98.644 19.3286 96.2523 21.0857C98.644 22.8429 100.743 24.9905 102.451 27.4309C105.184 31.3357 106.893 35.9726 107.234 41H97.5214C96.6428 32.9464 90.2 26.5036 82.1464 25.625V41H72.4333V1.22024H82.1464V16.5464C90.2 15.6679 96.6428 9.225 97.5214 1.17143H107.234Z"
      fill="currentColor"
    />
  </svg>
);
